module.exports = __webpack_public_path__ + "/login_ui/img/ws-57f8ef6d970c88166b3dd6c8cc4130fa.svg";